export default __webpack_public_path__ + "static/media/video-thumb.197f5760.png";